import { inEHomeApp } from '@/utils/ehome'

export default function native({ methodName, data = {} }) {
  return new Promise((resolve, reject) => {
    if (!inEHomeApp()) {
      return resolve(handlerDevelopEhome(methodName))
    }
    const ehome = window.EHome
    if (!ehome) {
      console.warn('ehome cordova未加载')
      return resolve(handlerDevelopEhome(methodName))
    }
    try {
      ehome.call(methodName, data, (res) => {
        console.log(`调用ehome方法:${methodName},返回结果${res}`)
        resolve(res)
      })
    } catch (error) {
      reject(error)
    }
  })
}

// 本地开发，E家的采取mock方式
function handlerDevelopEhome(methodName) {
  if (methodName === 'getAccountMessage') {
    return {
      // eslint-disable-next-line no-useless-escape
      sign: 'MrPKI9BfjdCgHpai+8zRbW8d6cjGMiWLJeeQtqOEXDoI6XN9b5t/Su84/QwIq5GFImcGtB985fooh/8x/8eEHgd5Y5qrKacu7zR1DjEwV2liyo9wvXg3I6GlBFjQ7QvNy5USVpHcPN9Iz6G0aTPlOcCa7WVOFsq5FwYyYmFp3xM=',
      // eslint-disable-next-line no-useless-escape
      data: 'ah0AXGTS/Y4aowxolyhnKCRDDV2oNzyTJaO70xGyW285sNVZ06JNJX6AOw8N7IS5gF7FjezmmL91l+5Wp+U7UIkxtklfMYHvJd9MHCW0YgpbdsO+4kblY40jMHIPZ+iq/b1o9+mm1nvSn76Y0qBbFcM4S0PZLvq1dfL070nJQ5vNdy62150bCZF77rvTU5+cQi2EXDnY+TGop8jMtXigjzAn0kfuuGoUiBjhLcjDkkHfp+hHZJdIObsls8viTWGr9FEvNl7Qrbdy5mLqC38elXmLFowru976ozZEToeARbYo0CSP6YDIUOMEZ6oEVJjAZotIb4/r4RkmRLSQM2O8Gw=='
    }
  }
  if (methodName === 'getAccountMessage') {
    return {
      username: process.env.VUE_APP_ACCOUNT,
      deviceId: 'ffffffff-832a-b8c3-3bcc-17030033c587',
      ssotoken: '0d2a7cfda6ee4a2fbc819703de4c10a3',
      url: 'com.csair.tableau.m',
      uuid: '74b680747bc347af8c68eaaa7f93fa2e',
      createTime: '1551945639568L'
    }
  }
}
